import React from 'react'
import { Row, Col } from "antd";
import rotate from "./rotate.png";

const ErrorThree = () => {
	const konverseLogoUrl = "https://uploads-ssl.webflow.com/5e960a73ae45f24b7959e93e/5e98af09a264bd68a6f91651_rsz_koverse_logo-p-500.png";
	return (
		<div className={`h-100 white`}>
			<div className="container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1">
				<div className="text-center" style={{marginTop:"1rem"}}>
					<img className="img-fluid" src={konverseLogoUrl} alt="" width={"200px"} />
				</div>
				<div style={{marginTop: "10%"}} className="container d-flex flex-column justify-content-center align-items-center ">
                    <img className="img-fluid" src={rotate} alt="rotate phone" width={"100px"}/>
					<Row align="middle">
						<Col xs={24} sm={24} md={24} className="text-center" style={{marginTop: "10%"}}>
							<h1 className="font-weight-bold display-5">Please rotate your device</h1>
							<p className="font-size-md mb-4">We don't support landscape mode.</p>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	)
}

export default ErrorThree;